export default {

    VOICE: {
        code: 1,
        title: '语音直播'
    },
    COURSE: {
        code: 2,
        title: '视频课程'   // 直播课
    },
    ACCOUNT: {
        code: 3,
        title: '账户资金变动'
    },
    COURSE_VOD: {
        code: 4,
        title: '点播课程'
    },
    GOLD_ACCOUNT: {
        code: 9,
        title: '账户金币变动'
    },
    GOLD_COURSE: {
        code: 14,
        title: '金币购买直播课程'
    },
    GOLD_COURSE_SEGMENT: {
        code: 15,
        title: '金币购买直播课程小节'
    },
    GOLD_COURSE_VOD: {
        code: 16,
        title: '金币购买点播课程'
    },
    OPEN_VIP: {
        code: 10,
        title: '开通VIP'
    },
    RENEW_VIP: {
        code: 11,
        title: '续费VIP'
    },
    // UNDERLINE_COURSE: {
    //     code: 17,
    //     title: '线下课'
    // },
    DATUM: {
        code: 26,
        title: '文档下载'
    },
    DISTRIBUTION_CLASS: {
        code: 32,
        title: '分销等级'
    },
    GO_ACTIVITY: {
        code: 34,
        title: '提前go活动'
    },
    COMBO: {
        code: 35,
        title: '套餐支付'
    },
    FREE_LEARN_VOD: {
        code: 36,
        title: '畅学课程'
    },
    BARGAIN: {
        code: 37,
        title: '砍价活动'
    },
    SECKILL: {
        code: 38,
        title: '秒杀'
    },
    MINI_COURSEWARE: {
        code: 39,
        title: '小程序课件'
    },
    THIRD_PARTY: {
        code: 40,
        title: '第三方工具服务/实物商品'
    },
    UNDERLINE_COURSE: {
        code: 41,
        title: '线下课'
    },
    ATLAS: {
        code: 42,
        title: '环创图集'
    },
    DISTRIBUTION_ROLE: {
        code: 43,
        title: '分销角色'
    },
    AGENCY_BALANCE: {
        code: 44,
        title: '代理商余额充值'
    },
    AGENCY_PRODUCT: {
        code: 45,
        title: '代理商产品'
    },
    POSTER_VIP_BUY: {
        code: 47,
        title: '海报会员'
    },

    /**
     * @param   String  title   biz type's title
     * @returns String          biz type's key
     * @author  zhiwen
     */
    getKeyByTitle : function (title) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].title == title)
            {
                return key;
            }
        }

        return '';
    },

    /**
     * @param   String  title   biz type's title
     * @returns String|Number   biz type's code
     * @author  zhiwen
     */
    getCodeByTitle : function (title) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].title == title)
            {
                return this[key].code;
            }
        }

        return '';
    }

}
